import { Component, OnInit } from '@angular/core';
import { AssetsService } from '../_services/assets.service';

@Component({
  selector: 'app-api-docs',
  templateUrl: './api-docs.component.html',
  styleUrls: ['./api-docs.component.css']
})
export class ApiDocsComponent implements OnInit {

  public exportPOSTCode: string = "";
  public submitPOSTCode: string = "";
  public submitInjectionPressurePOSTCode = "";
  public deleteCode: string = "";
  public deleteInjectionPressureCode: string = "";

  constructor(assetsService: AssetsService)
  {
    assetsService.getAssetAsString("assets/APIExamples/ExportPOST.py.txt").then((result) => {
      this.exportPOSTCode = result;
    });

    assetsService.getAssetAsString("assets/APIExamples/SubmitPOST.py.txt").then((result) => {
      this.submitPOSTCode= result;
    });

    assetsService.getAssetAsString("assets/APIExamples/SubmitInjectionPressurePOST.py.txt").then((result) => {
      this.submitInjectionPressurePOSTCode = result;
    });

    assetsService.getAssetAsString("assets/APIExamples/delete.py.txt").then((result) => {
      this.deleteCode = result;
    });

    assetsService.getAssetAsString("assets/APIExamples/DeleteInjectionPressure.py.txt").then((result) => {
      this.deleteInjectionPressureCode = result;
    });
  }

  ngOnInit(): void {
  }

}
